import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';

import { EmergencyContactComponent } from './emergency-contact/emergency-contact.component';
import { DependentComponent } from './dependent/dependent.component';
import { EducationalCredentialComponent } from './educational-credential/educational-credential.component';
import { ClearanceComponent } from './clearance/clearance.component';
import { GarnishmentComponent } from './garnishment/garnishment.component';
import { TrainingHistoryComponent } from './training-history/training-history.component';
import { SalaryHistoryComponent } from './salary-history/salary-history.component';
import { AppraisalHistoryComponent } from './appraisal-history/appraisal-history.component';
import { PhotoComponent } from './photo/photo.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { EmployeeAppraisalComponent } from './employee-appraisal/employee-appraisal.component';
import {PayeeDocumentComponent} from "./payee-document/payee-document.component";

@NgModule({
  declarations: [
    EmergencyContactComponent,
    DependentComponent,
    EducationalCredentialComponent,
    ClearanceComponent,
    GarnishmentComponent,
    TrainingHistoryComponent,
    SalaryHistoryComponent,
    AppraisalHistoryComponent,
    PhotoComponent,
    UserInfoComponent,
    EmployeeAppraisalComponent,
    PayeeDocumentComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [

    EmergencyContactComponent,
    DependentComponent,
    EducationalCredentialComponent,
    ClearanceComponent,
    GarnishmentComponent,
    TrainingHistoryComponent,
    SalaryHistoryComponent,
    AppraisalHistoryComponent,
    PhotoComponent,
    UserInfoComponent,
    EmployeeAppraisalComponent,
    PayeeDocumentComponent
  ]
})

export class HcmCommonModule { }
